import { RestClient, RestClientAuthenticated } from '../network';
import { AuthentificationAUTH04DTO } from './types/auth/AuthentificationAUTH04DTO';
import { Auth04Response } from './types/auth/Auth04Response';
import { LoginStatus } from './types/compte/LoginStatus';
import { ConnectLinksDTO } from './types/ConnectLinksDTO';

const activationApi = {
  authPhase4: (authentification: AuthentificationAUTH04DTO): Promise<Auth04Response> => new RestClientAuthenticated('/authentification/phase4', 'POST')
    .jsonBody(authentification)
    .execute(),
  fetchMyLoginStatus: (): Promise<LoginStatus> => new RestClientAuthenticated('/authentification/getCurrentUserLoginStatus', 'GET', 'application/json').execute(),
};
export default activationApi;
